import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import React from "react";
import {INSIDE_ORBIT_MENU_CONTAINER} from "./inside-orbit-menu-container.consts";
import {isInsideAutomation} from '../../../utils/automation-helpers';


export class InsideOrbitMenuContainerComponent extends OrbitComponent<{}> {
    render() {
        if(isInsideAutomation()) {
            return null;
        }
        return <div style={{display:"none", textAlign: "center"}} id={INSIDE_ORBIT_MENU_CONTAINER}/>
    }
}